export const SET_OFFER = 'SET_OFFER'
export const SET_USER_FIELD = 'SET_USER_FIELD'

export const SET_PARTICIPANTS = 'SET_PARTICIPANTS'
export const SET_HOTEL = 'SET_HOTEL'
export const SET_PARTICIPANT_FIELD = 'SET_PARTICIPANT_FIELD'
export const SET_FIRST_PARTICIPANT_FIELD = 'SET_FIRST_PARTICIPANT_FIELD'
export const FILL_FIRST_PARTICIPANT_FIELDS = 'FILL_FIRST_PARTICIPANT_FIELDS'

export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD'

export const SET_SELECTED_SERVICE = 'SET_ADDITIONAL_SERVICE'
export const SET_ADDITIONAL_SERVICES = 'SET_ADDITIONAL_SERVICES'
export const UPDATE_ADDITIONAL_SERVICES = 'UPDATE_ADDITIONAL_SERVICES'
export const DESELECT_SERVICE = 'DESELECT_SERVICE'

export const SET_RODO_STATEMENTS = 'SET_RODO_STATEMENTS'
export const SET_RODO_STATEMENT = 'SET_RODO_STATEMENT'

export const SET_SESSION_EXPIRED = 'SET_SESSION_EXPIRED'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js